import React from 'react';
import lazarus from '../images/Mch. Lazarus.jpg'
import {YouTube, FacebookOutlined, Twitter, Instagram, WhatsApp} from "@mui/icons-material";
import mwenyekiti from "../images/KIHOZA.jpg"

const Mawasiliano = () => {
    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission here
        console.log('Form submitted');
    };


    const leaders = [
        {
            id: 2,
            name: "Mch. Dr. Baraka E. Kihoza",
            denomination: "Katibu Mkuu",
            position: "0765779336",
            image: "https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/viongozi%2FIMG_9958.jpg?alt=media&token=2a9d80c8-6177-4858-b1d3-f5988381044f"
        },

        {
            id: 5,
            name: "Gladness Clement Lema",
            position: "0719580831",
            denomination: "Katibu Muhtasi",
            image: "https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/viongozi%2FIMG_9959.jpg?alt=media&token=850b51ca-2854-4996-930a-8d7f86ab2e57"
        },

        {
            id: 8,
            name: "Mch. Stephano Bahati Maige",
            position: "0713592216",
            denomination: "Mtunza Hazina",
            image: "https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/viongozi%2FIMG_9960.jpg?alt=media&token=ce745ff4-33b6-4ff5-bef8-5b6960218cc9"
        },
        {
            id: 3,
            name: "Mch. Lazarus Laizer",
            position: "0768558668",
            denomination: "Mkurugenzi Idara ya Habari",
            image: `${lazarus}`
        },

    ];

    return (
        <div className="flex flex-col  text-text-light dark:text-text-dark font-display">
            <main className="flex-grow container mx-auto px-6 py-6 md:py-12 ">
                <div className="flex flex-col lg:flex-row gap-8 items-start">

                    <div className="bg-surface-light bg-gray-200 dark:bg-surface-dark  rounded-lg shadow-lg">
                        <img className={'rounded-xl'}
                             src={mwenyekiti}
                             alt=""/>
                    </div>


                    <div className="flex w-full h-full flex-col gap-10 bg-white p-8 rounded-xl shadow-sm">


                        <div className={'flex flex-col items-stretch md:flex-row gap-12'}>
                            <div className="space-y-6">
                                <h3 className="text-xl font-bold text-text-light dark:text-text-dark border-b border-border-light dark:border-border-dark pb-3">
                                    Mawasiliano
                                </h3>
                                <div className="space-y-4">
                                    <div className="flex items-start gap-4">
                                        <div
                                            className="bg-primary/10 dark:bg-secondary/10 p-3 rounded-full text-primary dark:text-secondary mt-1">
                                            <svg fill="none" height="20" stroke="currentColor" strokeLinecap="round"
                                                 strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="20"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                                <circle cx="12" cy="10" r="3"></circle>
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="font-bold text-text-light dark:text-text-dark">Anwani</p>
                                            <p className="text-text-muted-light dark:text-text-muted-dark">P.O.Box 529
                                                Dodoma<br></br>Tanzania</p>
                                        </div>
                                    </div>

                                    <div className="flex items-start gap-4">
                                        <div
                                            className="bg-primary/10 dark:bg-secondary/10 p-3 rounded-full text-primary dark:text-secondary mt-1">
                                            <svg fill="none" height="20" stroke="currentColor" strokeLinecap="round"
                                                 strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="20"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                                                </path>
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="font-bold text-text-light dark:text-text-dark">Simu</p>
                                            <p className="text-text-muted-light dark:text-text-muted-dark">+255 767 558
                                                668</p>
                                        </div>
                                    </div>

                                    <div className="flex items-start gap-4">
                                        <div
                                            className="bg-primary/10 dark:bg-secondary/10 p-3 rounded-full text-primary dark:text-secondary mt-1">
                                            <svg fill="none" height="20" stroke="currentColor" strokeLinecap="round"
                                                 strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="20"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z">
                                                </path>
                                                <polyline points="22,6 12,13 2,6"></polyline>
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="font-bold text-text-light dark:text-text-dark">Barua pepe</p>
                                            <p className="text-text-muted-light dark:text-text-muted-dark">info@cpct.or.tz</p>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="space-y-6">
                                <h3 className="text-xl font-bold text-text-light dark:text-text-dark border-b border-border-light dark:border-border-dark pb-3">
                                    Mitandao ya Kijamii
                                </h3>


                                <div className="flex flex-col gap-2">
                                    <a href="https://www.youtube.com/@THECPCTTV">
                                        <div className={'flex items-center gap-4'}>
                                            <div
                                                className="w-10 h-10 flex items-center justify-center rounded-full bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark text-text-muted-light dark:text-text-muted-dark hover:bg-primary/10 dark:hover:bg-secondary/10 hover:text-primary dark:hover:text-secondary transition-colors">
                                                <YouTube/></div>
                                            <div>
                                                <div>The CPCT TV</div>
                                            </div>
                                        </div>
                                    </a>
                                    <a href="https://web.facebook.com/p/The-Cpct-Tanzania-100091892024001/?_rdc=1&_rdr#">
                                        <div className={'flex items-center gap-4'}>
                                            <div
                                                className="w-10 h-10 flex items-center justify-center rounded-full bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark text-text-muted-light dark:text-text-muted-dark hover:bg-primary/10 dark:hover:bg-secondary/10 hover:text-primary dark:hover:text-secondary transition-colors">
                                                <FacebookOutlined/></div>
                                            <div>
                                                <div>The CPCT Tanzania</div>
                                            </div>
                                        </div>
                                    </a>

                                    <a href="https://x.com/thecpctz?lang=en">
                                        <div className={'flex items-center gap-4'}>
                                            <div
                                                className="w-10 h-10 flex items-center justify-center rounded-full bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark text-text-muted-light dark:text-text-muted-dark hover:bg-primary/10 dark:hover:bg-secondary/10 hover:text-primary dark:hover:text-secondary transition-colors">
                                                <Twitter/></div>
                                            <div>
                                                <div>@thecpctz</div>
                                            </div>
                                        </div>
                                    </a>

                                    <a href="https://www.instagram.com/thecpcttanzania/">
                                        <div className={'flex items-center gap-4'}>
                                            <div
                                                className="w-10 h-10 flex items-center justify-center rounded-full bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark text-text-muted-light dark:text-text-muted-dark hover:bg-primary/10 dark:hover:bg-secondary/10 hover:text-primary dark:hover:text-secondary transition-colors">
                                                <Instagram/></div>
                                            <div>
                                                <div>@thecpcttanzania</div>
                                            </div>
                                        </div>
                                    </a>

                                    <a href="https://wa.me/255767558668">
                                        <div className={'flex items-center gap-4'}>
                                            <div
                                                className="w-10 h-10 flex items-center justify-center rounded-full bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark text-text-muted-light dark:text-text-muted-dark hover:bg-primary/10 dark:hover:bg-secondary/10 hover:text-primary dark:hover:text-secondary transition-colors">
                                                <WhatsApp/></div>
                                            <div>
                                                <div>+255 767 558 668</div>
                                            </div>
                                        </div>
                                    </a>



                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <br></br>
                <br></br>

                <div className={'bg-white dark:bg-gray-800  rounded-2xl shadow-md p-8 mb-8'}>
                    {/*<h2 className="text-3xl text-center font-bold text-gray-900 dark:text-white mb-8">Viongozi wa Kitaifa</h2>*/}
                    <div className=" mt-4 flex flex-wrap justify-center  gap-16">
                        {leaders.map((leader) => (
                            <div key={leader.id} className="group flex flex-col items-center text-center">
                                <div className="relative h-40 w-40 aspect-square overflow-hidden rounded-3xl">
                                    <img
                                        alt={leader.name}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                        src={leader.image}
                                    />
                                    <div
                                        className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                                </div>
                                <div className="mt-6">
                                    <h3 className="font-bold text-lg"
                                        style={{lineHeight: '1.1'}}>{leader.name}</h3>
                                    <p className="text-gray-600 text-md ">{leader.denomination}</p>
                                    <hr className="border-t border-gray-200 my-1"/>
                                    <p className="text-sky-800 font-semibold text-md ">{leader.position}</p>

                                </div>
                            </div>
                        ))}
                    </div>
                </div>


            </main>


        </div>
    );
};

export default Mawasiliano;